import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})

export class UtilsService {

	static distinct(arr, prop) {

		const result = [];

		const map = new Map();
		for (const item of arr) {
			if (!map.has(item[prop])) {
				map.set(item[prop], true);
				result.push(item);
			}
		}

		return result;
	}

	async delay(ms: number) {
		//await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log(''));
	}
}
